import React, { Component } from 'react';
import LanguageUtil from '../../../../util/LanguageUtil';

class WatchlistAlertReasonComponent extends Component<Props, State> {
  public state: State = new State();

  public render() {
    const { value } = this.props;
    return (
      <div className='w-full flex flex-col gap-[7px]'>
        <div className='flex w-full items-center justify-between'>
          <div className={'text-sm text-f-black-2'}>{LanguageUtil.get({ id: 'pages.alert.reasonOptional', defaultMessage: 'Reason (Optional)' })}</div>
        </div>
        <textarea className={'border-[1px] min-h-[200px] p-2 border-[#E0E4E8] rounded-[4px] w-full h-full'} value={value} onChange={this.onChangeReason} />
      </div>
    );
  }

  private onChangeReason = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { onChange } = this.props;
    onChange(e.currentTarget.value);
  };
}

interface Props {
  value: string | undefined;
  onChange: (value: string) => void;
}

class State {}

export default WatchlistAlertReasonComponent;
